import React, { useState, useEffect, useMemo } from 'react';
import { useSearchParams ,useLocation} from 'react-router-dom';
import './AIReportDisplay.css';
// NEW: Import jsPDF and html2canvas for PDF generation
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Counselling from './Counselling';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';

// Image imports (ensure paths are correct)
// Removed all static images except the student profile fallback
import studentImage from '../assets/images/student.jpg';

const REACT_APP_API_BASE = process.env.REACT_APP_API_BASE ;



// HELPER FUNCTION TO FORMAT NUMBERS (IMPROVED)
const formatToLakhs = (num) => {
    if (num === null || num === undefined || num === 'N/A' || num === '') {
        return 'N/A';
    }
    const numStr = String(num);
    // If it's already formatted as Lakhs/Crore, just clean and return
    if (numStr.toLowerCase().includes('lakh') || numStr.toLowerCase().includes('crore')) {
        return `₹ ${numStr.replace(/INR/gi, '').trim()}`;
    }
    // Extract numbers from strings like "INR 8,00,000"
    const number = Number(numStr.replace(/[^0-9.-]+/g, ""));
    if (isNaN(number)) {
        return num; // Return original string if it's not a parsable number
    }
    if (number >= 10000000) {
        const value = (number / 10000000).toFixed(2).replace(/\.00$/, '');
        return `₹ ${value} Crore`;
    } else if (number >= 100000) {
        const value = (number / 100000).toFixed(2).replace(/\.00$/, '');
        return `₹ ${value} Lakh`;
    }
    return `₹ ${number.toLocaleString('en-IN')}`;
};


   

// --- Helper Components ---
const QnAItem = ({ item }) => (
    <div className="qna-item">
        <p className="qna-question">{item?.question || 'N/A'}</p>
        <p className="qna-answer">{item?.answer || 'N/A'}</p>
    </div>
);

const ScholarshipCard = ({ scholarships }) => {
    if (!scholarships || scholarships.length === 0) return null;

    return (
        <div className="data-card">
            <h3 className="data-card__title"><i className='bx bxs-award'></i>Scholarship Details</h3>
            {scholarships.map((scholarship, index) => (
                <div key={index} className="scholarship-item qna-item">
                    <h4 className="scholarship-name">{scholarship.name}</h4>
                    <p><span className="text-accent">Amount:</span> {formatToLakhs(scholarship.amount?.inr)} ({scholarship.amount?.local})</p>
                    <p><span className="text-accent">Criteria:</span> {scholarship.criteria}</p>
                    <p><span className="text-accent">How to Claim:</span> {scholarship.claimInstructions}</p>
                </div>
            ))}
        </div>
    );
};

const KeyValueCard = ({ title, icon, data }) => { // Removed 'image' prop
    if (!data) return null;
    const entries = Object.entries(data).filter(([_, value]) => value && value !== 'Not Provided' && value.length > 0);
    if (entries.length === 0) return null;

    const formatKey = (key) => key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());

    return (
        <div className="data-card">
            <h3 className="data-card__title"><i className={`bx ${icon}`}></i>{title}</h3>
            {/* Removed image tag */}
            <ul className="profile-detail-list">
                {entries.map(([key, value]) => (
                    <li key={key}><span>{formatKey(key)}</span><strong>{value.toString()}</strong></li>
                ))}
            </ul>
        </div>
    );
};

// MODIFIED: CostAnalysis component updated with currency toggle and new layout
const CostAnalysis = ({ fullCostOfLiving, educationCosts, primaryRecommendation, totalFirstYearInr }) => {
    const [selectedCurrency, setSelectedCurrency] = useState('inr');

    const formatLocalCurrency = (value) => value || 'N/A';

    // Define the order and labels for cost items to ensure consistency
    const costItemsConfig = [
        { key: 'accommodation', label: 'Accommodation' },
        { key: 'cityLivingCost', label: 'City Living Cost' },
        { key: 'transportcost', label: 'Transport Cost' },
        { key: 'foodAndGroceryCost', label: 'Food And Grocery Cost' },
        { key: 'miscellaneous', label: 'Miscellaneous' },
    ];

    const orderedCosts = costItemsConfig
        .map(config => {
            const dataKey = Object.keys(fullCostOfLiving || {}).find(k => k.toLowerCase().startsWith(config.key));
            if (dataKey && fullCostOfLiving[dataKey]) {
                const value = fullCostOfLiving[dataKey];
                const hasMonthly = dataKey.toLowerCase().includes('monthly');
                return { ...config, value, hasMonthly, dataKey };
            }
            return null;
        })
        .filter(Boolean);

    return (
        <div className="data-card">
            <h3 className="data-card__title"><i className='bx bx-wallet'></i>Cost Analysis ({primaryRecommendation?.city || 'N/A'})</h3>

            {/* --- Currency Toggle Buttons --- */}
            <div className="currency-toggle">
                <button
                    className={`toggle-button ${selectedCurrency === 'inr' ? 'active' : ''}`}
                    onClick={() => setSelectedCurrency('inr')}
                >
                    INR (₹)
                </button>
                <button
                    className={`toggle-button ${selectedCurrency === 'local' ? 'active' : ''}`}
                    onClick={() => setSelectedCurrency('local')}
                >
                    Local
                </button>
            </div>

            <div className="cost-items-container">
                <div className="cost-analysis-item">
                    <div className="cost-label-group">
                        <span className="cost-label-main">Tuition</span>
                        <span className="cost-label-sub">Yearly</span>
                    </div>
                    <span className="cost-value">
                        {selectedCurrency === 'inr'
                            ? formatToLakhs(primaryRecommendation?.tuition?.inr)
                            : formatLocalCurrency(primaryRecommendation?.tuition?.local)
                        }
                    </span>
                </div>


                {orderedCosts.map(({ dataKey, label, value, hasMonthly }) => (
                    <div className="cost-analysis-item" key={dataKey}>
                        <div className="cost-label-group">
                            <span className="cost-label-main">{label}</span>
                            {hasMonthly && <span className="cost-label-sub">Monthly</span>}
                        </div>
                        <span className="cost-value">
                            {selectedCurrency === 'inr'
                                ? formatToLakhs(value.inr)
                                : formatLocalCurrency(value.local)
                            }
                        </span>
                    </div>
                ))}

                {educationCosts?.hiddenCosts && (
                    <div className="cost-analysis-item">
                        <div className="cost-label-group">
                            <span className="cost-label-main">Hidden Costs</span>
                        </div>
                        <span className="cost-value-description">{educationCosts.hiddenCosts}</span>
                    </div>
                )}
            </div>

            <hr />

            <div className="cost-analysis-item total">
                <span className="cost-label-main">Est. First Year</span>
                <span className="cost-value-total">{formatToLakhs(totalFirstYearInr)}</span>
            </div>
        </div>
    );
};

// REFACTORED: DetailedCollegeCard component with new structure and classes
const DetailedCollegeCard = ({ college, rank, collegeAnalysis }) => {
    if (!college) return null;

    // Helper to format acceptance rate
    const formatAcceptanceRate = (rate) => {
        if (rate === null || rate === undefined || rate === 'N/A' || rate === '') return 'N/A';
        const num = String(rate).replace(/%/g, '').trim(); // Remove any existing '%'
        if (!isNaN(num) && num !== '') {
            return `${num}%`;
        }
        return rate;
    };

    return (
        <div className="detailed-college-card data-card">
            <div className="detailed-college-header">
                <span className="rank-badge">#{rank}</span>
                <h3 className="college-name">
                    {college.college || 'N/A'} ({college.state || 'N/A'})
                </h3>
            </div>

            <div className="college-section-wrapper">
                {/* Main Details Section */}
                <div className="college-main-details">
                    <p><span className="detail-label">Course:</span><span className="detail-value">{college.courseName || 'N/A'}</span></p>
                    <p><span className="detail-label">Intake:</span><span className="detail-value">{college.intake || 'N/A'}</span></p>
                    <p><span className="detail-label">Duration:</span><span className="detail-value">{college.duration || 'N/A'}</span></p>
                    <p><span className="detail-label">Tuition:</span><span className="detail-value">{college.tuition?.local || 'N/A'} | {formatToLakhs(college.tuition?.inr)}</span></p>
                    <p><span className="detail-label">Deadline:</span><span className="detail-value">{college.applicationDeadline || 'N/A'}</span></p>
                    <p><span className="detail-label">Acceptance Rate:</span><span className="detail-value">{formatAcceptanceRate(college.acceptanceRate)}</span></p>
                </div>

                {/* College Analysis Section */}
                {collegeAnalysis && (
                    <div className="detailed-college-section">
                        <h4 className="data-card__title">College Analysis</h4>
                        <p><strong>Reputation:</strong> {collegeAnalysis.rankingAndReputation || 'N/A'}</p>
                        <p><strong>Accreditation:</strong> {collegeAnalysis.accreditationRecognition || 'N/A'}</p>
                        <p><strong>Research Focus:</strong> {collegeAnalysis.facultyResearchOpportunities || 'N/A'}</p>
                    </div>
                )}


                {/* Other Sections */}
                <div className="detailed-college-section">
                    <h4>Entry Requirements</h4>
                    <p>{college.entryRequirements || 'N/A'}</p>
                </div>
                <div className="detailed-college-section">
                    <h4>Curriculum</h4>
                    <p>{college.curriculumSummary || 'N/A'}</p>
                </div>
                <div className="detailed-college-section">
                    <h4>Top Employers</h4>
                    <p>{(Array.isArray(college.topEmployers) ? college.topEmployers : [college.topEmployers]).join(', ')}</p>
                </div>
            </div>
        </div>
    );
};

const CounsellingModal = ({ show, onClose }) => {
    if (!show) return null;
    return (
        <div className={`counselling-modal-backdrop ${show ? 'show' : ''}`}>
            <div className="counselling-modal-window">
                <button onClick={onClose} className="counselling-modal-close">×</button>
                <Counselling onBookingSuccess={onClose} isInsideModal={true} />
            </div>
        </div>
    );
};


// --- Main Report Component ---
const AIReportDisplay = () => {
    const [searchParams] = useSearchParams();
    const reportId = searchParams.get('id');

    // State for data fetching, loading, and error
    const [reportData, setReportData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // Existing state for UI interactions
    const [isMounted, setIsMounted] = useState(false);
    const [isSopExpanded, setIsSopExpanded] = useState(false);
    const [showCounsellingPopup, setShowCounsellingPopup] = useState(false);
    const [isDownloadingPdf, setIsDownloadingPdf] = useState(false);
    

    const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

    // Data fetching logic
    useEffect(() => {
        if (!reportId) {
            setError('No Report ID provided in the URL.');
            setIsLoading(false);
            return;
        }

        const fetchReport = async () => {
            setIsLoading(true);
            try {
                const { data } = await axios.get(`${REACT_APP_API_BASE}/api/reports/single/${reportId}`);
                setReportData(data.aiResults); // We only need the aiResults part
            } catch (err) {
                setError(err.response?.data?.message || 'Failed to fetch the report data.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchReport();
    }, [reportId]);
    
    const toggleSopExpansion = () => setIsSopExpanded(!isSopExpanded);

      const transformedData = useMemo(() => {
        const data = reportData; // Use the state variable which holds the fetched aiResults
        if (!data || Object.keys(data).length === 0) return null;

        // For the standard report, the data structure is simpler.
        const recommendation = {
            college: data.studentInfo?.selectedCollege || 'N/A',
            state: data.studentInfo?.selectedState || 'N/A',
            city: data.specificCollegeReport?.campusLocationCity || 'N/A',
            courseName: data.specificCollegeReport?.courseName || 'N/A',
            intake: data.specificCollegeReport?.intake || 'N/A',
            duration: data.specificCollegeReport?.duration || 'N/A',
            tuition: data.specificCollegeReport?.tuitionFee,
            applicationDeadline: data.specificCollegeReport?.applicationDeadline || 'N/A',
            acceptanceRate: data.specificCollegeReport?.acceptanceRatePercent || 'N/A',
            successProbability: data.specificCollegeReport?.successProbabilityPercent || 'N/A',
            entryRequirements: data.specificCollegeReport?.entryRequirements || 'N/A',
            curriculumSummary: data.specificCollegeReport?.courseCurriculumSummary || 'N/A',
            topEmployers: data.specificCollegeReport?.topEmployers,
        };

        return {
            studentInfo: data.studentInfo || {},
            collegeAnalysis: data.collegeAnalysis,
            recommendations: recommendation.college !== 'N/A' ? [recommendation] : [],
            jobMarket: data.jobMarketSnapshot,
            visaAndSOP: data.visaAndSOPAdvice,
            educationCosts: data.educationCostBreakdown,
            livingCosts: {
                totalFirstYear: data.timelineInvestmentPlanning?.firstYearTotalCost,
            },
            fullCostOfLiving: data.costOfLiving,
            accommodationInsights: data.livingCostAccommodationInsights,
            flightCostsTips: data.flightCostsTips,
            additionalCertifications: data.additionalCertifications || [],
            scholarshipDetails: data.scholarshipDetails,
            intakeDeadlines: data.timelineInvestmentPlanning?.applicationDeadlines,
            visaMilestones: data.timelineInvestmentPlanning?.visaMilestones,
            admissionRequirements: data.admissionEaseAndRequirements,
            careerAlignment: data.careerGoalsAlignment,
            roi: data.returnOnInvestment,
            peerInfluence: data.peerParentalInfluence,
            connectivityLifestyle: data.travelConnectivityLifestyle,
            prPathway: data.prPathwayRoadmap,
            finalActionPlan: data.finalActionPlan,
            backupPlan: data.backupCourseCountry ? {
                course: data.backupCourseCountry.courseAndCollege,
                whySafer: data.backupCourseCountry.reasonSaferPractical,
                prRoute: data.backupCourseCountry.prRoute,
            } : null,
            predictedQnA: data.predictedQnA,
            finalComment: data.finalComment,
            footerResources: data.footerResources,
            familyBackgroundFinancialViability: data.familyBackgroundFinancialViability,
            postStudyWorkAndPR: data.postStudyWorkAndPR,
            countrySafetyAndPreference: data.countrySafetyAndPreference,
        };
    }, [reportData]);
    useEffect(() => {
        const mountTimer = setTimeout(() => setIsMounted(true), 100);
        const popupTimer = setTimeout(() => {
            if (transformedData) {
                setShowCounsellingPopup(true);
            }
        }, 20000);

        return () => {
            clearTimeout(mountTimer);
            clearTimeout(popupTimer);
        };
    }, [transformedData]);

    useEffect(() => {
        if (showCounsellingPopup) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showCounsellingPopup]);

    // UPDATED: Function to handle PDF download using jsPDF and html2canvas
    const handleDownloadReport = async () => {
        // We will target the inner report-container to avoid capturing the empty space from the wrapper.
        const reportElement = document.getElementById('report-container');
        if (!reportElement) {
            console.error("Report element with ID 'report-container' not found!");
            return;
        }

        setIsDownloadingPdf(true);

        // Temporarily remove animations to prevent them from being captured mid-transition
        reportElement.classList.add('pdf-render-mode');

        try {
            const canvas = await html2canvas(reportElement, {
                scale: 2, // Higher scale for better quality
                useCORS: true, // Necessary for external images
                logging: false, // Suppress logs in console
                scrollY: -window.scrollY, // Capture from the top of the element
                windowWidth: reportElement.scrollWidth,
                windowHeight: reportElement.scrollHeight,
            });

            const imgData = canvas.toDataURL('image/png', 1.0);

            // A4 page dimensions in mm [width, height]
            const pdf = new jsPDF('p', 'mm', 'a4');
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const imgProps = pdf.getImageProperties(imgData);
            const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

            let heightLeft = imgHeight;
            let position = 0;

            // Add first page
            pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
            heightLeft -= pdfHeight;

            // Add subsequent pages if content overflows
            while (heightLeft > 0) {
                position = -heightLeft;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
                heightLeft -= pdfHeight;
            }

            const fileName = `AI-Report-${transformedData.studentInfo?.name?.replace(/\s+/g, '_') || 'Student'}.pdf`;
            pdf.save(fileName);

        } catch (error) {
            console.error("Error generating PDF: ", error);
            alert("Sorry, there was an error generating the PDF. Please try again.");
        } finally {
            // Restore animations after capture
            reportElement.classList.remove('pdf-render-mode');
            setIsDownloadingPdf(false);
        }
    };

    // Add this to your CSS file (e.g., AIReportDisplay.css) to disable animations during PDF rendering:
    // .pdf-render-mode * {
    //   transition: none !important;
    //   animation: none !important;
    // }

    if (!transformedData) {
        return <div className="ai-report-wrapper"><p>Loading Report Data...</p></div>;
    }

    const {
        studentInfo, recommendations, jobMarket, visaAndSOP, livingCosts, educationCosts, prPathway, finalActionPlan,
        backupPlan, predictedQnA, finalComment, footerResources, scholarshipDetails, collegeAnalysis, familyBackgroundFinancialViability,
        additionalCertifications, postStudyWorkAndPR, countrySafetyAndPreference, flightCosts, fullCostOfLiving, accommodationInsights,
        flightCostsTips, intakeDeadlines, visaMilestones, admissionRequirements, careerAlignment, roi, peerInfluence, connectivityLifestyle
    } = transformedData;

    const allRecommendations = Array.isArray(recommendations) ? recommendations : [];
    const primaryRecommendation = allRecommendations?.[0];

    const getPercentage = (text) => {
        if (!text) return 0;
        const match = String(text).match(/(\d+)/);
        return match ? parseInt(match[1], 10) : 0;
    };

    const getVisaRiskForCollege = () => {
        return visaAndSOP ? getPercentage(visaAndSOP.rejectionRiskPercentReasons) : 0;
    };

    const renderRecommendations = () => {
        if (!allRecommendations || allRecommendations.length === 0) {
            return (
                <div className="data-card" style={{ '--i': 0 }}>
                    <p>No college recommendations were generated for this report.</p>
                </div>
            );
        }
        return allRecommendations.map((college, index) => (
            <div style={{ '--i': index }} key={college?.college || index}>
                <DetailedCollegeCard college={college} rank={index + 1} collegeAnalysis={collegeAnalysis} />
            </div>
        ));
    };

    return (
        <>
            <Helmet>
                <meta name="title" content="Home | Get Next Visa - AI Powered Student Visa Report" />
                <title>Home | Get Next Visa - AI Powered Student Visa Report</title>
                <meta name="description" content="Get personalized, AI-powered visa reports. Discover the best countries and colleges for your study abroad journey." />
            </Helmet>

            <CounsellingModal show={showCounsellingPopup} onClose={() => setShowCounsellingPopup(false)} />

            <div id="pdf-capture-wrapper">
                <div id="report-container" className={`ai-report-wrapper ${isMounted ? 'mounted' : ''}`}>
<header className="report-header">
    <div className="report-header__content">
        <div className="report-header__brand">
            <h2 className="report-header__tagline">Immigration & Education Report</h2>
        </div>
        
        {/* === START: UPDATED JSX FOR BUTTONS === */}
        <div className="report-header__actions">
            <button className="action-button" onClick={() => setShowCounsellingPopup(true)}>
                <i className='bx bxs-calendar-plus'></i>
                <span>Book a Counselling</span>
            </button>
            {/* <button className="action-button" onClick={handleDownloadReport} disabled={isDownloadingPdf}>
                {isDownloadingPdf ? (
                    <>
                        <i className='bx bx-loader-alt bx-spin'></i>
                        <span>Downloading...</span>
                    </>
                ) : (
                    <>
                        <i className='bx bxs-file-pdf'></i>
                        <span>Download Report</span>
                    </>
                )}
            </button> */}
        </div>
        {/* === END: UPDATED JSX FOR BUTTONS === */}

    </div>
</header>

                    <div className="report-main-grid">
                        <aside className="report-main-grid__side-column--left">
                            {studentInfo && <div className="data-card student-profile-card" style={{ '--i': 0 }}>
                                <div className="student-profile-card__header">
                                    <img src={studentInfo?.avatarUrl || studentImage} alt={studentInfo?.name || 'Student'} />
                                    <h3 className="student-profile-card__name">{studentInfo?.name || 'Student Name'}</h3>
                                </div>
                                <div className="student-profile-card__body">
                                    <div className="profile-section">
                                        <h4 className="profile-section__title">
                                            <i className='bx bxs-graduation'></i> Academic & Test Scores
                                        </h4>
                                        <ul className="profile-detail-list">
                                            {/* Academic Background */}
                                            <li>
                                                <span className="academic-section-title">Background</span>
                                              <div className="academic-background-lines">
    {studentInfo.academicBackground
        ? studentInfo.academicBackground.split(',').map((line, index) => {
            // Split only on the first colon to handle values that might contain colons
            const parts = line.split(/:(.*)/s);
            const label = parts[0];
            const value = parts[1]; // This will be undefined if no colon exists

            // If there's no value (no colon in the line), render the whole line as the value
            if (value === undefined) {
                return (
                    <div key={index} className="academic-line">
                        <span className="academic-value">{label.trim()}</span>
                    </div>
                );
            }

            // Otherwise, render label and value
            return (
                <div key={index} className="academic-line">
                    <span className="academic-label">{label.trim()}:</span>
                    <span className="academic-value">{value.trim()}</span>
                </div>
            );
        })
        : <div className="academic-line">N/A</div>}
</div>

                                            </li>

                                            {/* Exam Scores */}
                                            {(() => {
                                                const exams = [
                                                    ['PTE Score:', studentInfo.pteScore],
                                                    ['TOEFL Score:', studentInfo.toeflScore],
                                                    ['IELTS Score Overall:', studentInfo.ieltsScore],
                                                ];
                                                const valid = exams.filter(([, score]) => score != null && score !== '');

                                                if (valid.length === 0) {
                                                    return (
                                                        <li className="academic-line exam-score-line">
                                                            <span className="academic-label">Exam</span>
                                                            <span className="academic-value">N/A</span>
                                                        </li>
                                                    );
                                                }

                                                return valid.map(([label, score]) => (
                                                    <li key={label} className="academic-line exam-score-line">
                                                        <span className="academic-label">{label}</span>
                                                        <span className="academic-value">{score}</span>
                                                    </li>
                                                ));
                                            })()}

                                        </ul>
                                    </div>




                                    <div className="profile-section">
                                        <h4 className="profile-section__title">
                                            <i className='bx bxs-wallet'></i>Financials
                                        </h4>
                                        <div className="financials-list">
                                            <p><strong>Budget:</strong> {studentInfo.budgetRange || 'N/A'}</p>
                                            <p><strong>Bank Balance (Liquid):</strong> {studentInfo.familyBankBalance?.liquid || 'N/A'}</p>
                                            <p><strong>Bank Balance (Fixed Deposit):</strong> {studentInfo.familyBankBalance?.fixedDeposit || 'N/A'}</p>
                                        </div>
                                    </div>



                                    {(studentInfo.father || studentInfo.mother) && (
                                        <div className="profile-section">
                                            <h4 className="profile-section__title">
                                                <i className='bx bxs-user'></i>Family Background
                                            </h4>
                                            <ul className="profile-detail-list">
                                                {[
                                                    ["Father’s Employment", studentInfo.father?.employmentStatus],
                                                    ["Father’s Experience", studentInfo.father?.experience],
                                                    ["Mother’s Employment", studentInfo.mother?.employmentStatus],
                                                    ["Mother’s Experience", studentInfo.mother?.experience],
                                                ].map(([label, value]) => (
                                                    <li key={label} className="academic-line">
                                                        <span className="academic-label">{label}</span>
                                                        <span className="academic-value">{value || "N/A"}</span>
                                                    </li>
                                                ))}
                                            </ul>

                                        </div>
                                    )}


                                    {familyBackgroundFinancialViability && (
                                        <div className="profile-section">
                                            <h4 className="profile-section__title">
                                                <i className='bx bxs-bank'></i>Financial Viability
                                            </h4>
                                            <ul className="profile-detail-list">
                                                <li key="assessment" className="academic-line">
                                                    <span className="academic-label">Assessment</span>
                                                    <span className="academic-value">
                                                        {familyBackgroundFinancialViability.bankBalanceViabilityCheck || "N/A"}
                                                    </span>
                                                </li>

                                                {familyBackgroundFinancialViability.recommendations.map((rec, i) => (
                                                    <li key={i} className="academic-line">
                                                        <span className="academic-label">Recommendation</span>
                                                        <span className="academic-value">{rec}</span>
                                                    </li>
                                                ))}

                                            </ul>
                                        </div>
                                    )}
                                </div>

                            </div>}

                            {visaAndSOP && <div className="data-card" style={{ '--i': 1 }}>
                                <h3 className="data-card__title"><i className='bx bxs-file-blank'></i>Visa Documentation</h3>
                                <div className="visa-details">
                                    <p><span className="text-accent">Visa Type:</span> {visaAndSOP?.visaType || 'N/A'}</p>
                                    <h4 className="data-card__subtitle text-accent" style={{ marginTop: '1rem' }}>Document Checklist</h4>
                                    <ul className='icon-list'>
                                        {Array.isArray(visaAndSOP?.documentChecklist) && visaAndSOP.documentChecklist.map(doc => (<li key={doc}><i style={{ color: "var(--success-color)" }} className='bx bx-check-square'></i>{doc}</li>))}
                                    </ul>
                                </div>
                            </div>}

                            {collegeAnalysis?.courseSpecializations && (
                                <div className="data-card" style={{ '--i': 2 }}><h3 className="data-card__title">🎓 Curriculum Specializations</h3><p>{collegeAnalysis.courseSpecializations}</p></div>
                            )}

                            {accommodationInsights && (
                                <div className="data-card" style={{ '--i': 3 }}>
                                    <h3 className="data-card__title">🏘️ Accommodation Insights</h3>
                                    <ul className="profile-detail-list">
                                        {/* …other items… */}

                                        {accommodationInsights.bestAreasToLive && (
                                            <li className="academic-line">
                                                <span className="academic-label">Best Areas</span>
                                                <span className="academic-value">
                                                    {accommodationInsights.bestAreasToLive}
                                                </span>
                                            </li>
                                        )}

                                        <li className="academic-line">
                                            <span className="academic-label">Safety Score</span>
                                            <span className="academic-value">{accommodationInsights.safetyScore}</span>
                                        </li>
                                        <li className="academic-line">
                                            <span className="academic-label">Tips</span>
                                            <span className="academic-value">{accommodationInsights.housingPlatformTips}</span>
                                        </li>
                                    </ul>
                                </div>
                            )}



                            {additionalCertifications?.length > 0 && (
                                <div className="data-card" style={{ '--i': 4 }}>
                                    <h3 className="data-card__title"><i className='bx bxs-receipt'></i>Additional Certifications</h3>
                                    <ul className="profile-detail-list">
                                        {additionalCertifications.map((cert, i) => (
                                            <li key={i} className="academic-line">
                                                <span className="academic-label">{cert.name}</span>
                                                <span className="academic-value">
                                                    {cert.inr} | {cert.local}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}



                            {(intakeDeadlines?.length > 0 || visaMilestones?.length > 0) && (
                                <div style={{ '--i': 5 }} className="data-card">
                                    {intakeDeadlines?.length > 0 && (
                                        <>
                                            <h3 className="data-card__title"><i className='bx bxs-calendar'></i>Upcoming Application Deadlines</h3>
                                            <ul className="profile-detail-list">
                                                {intakeDeadlines.map(({ label, dueDate }) => (
                                                    <li key={label} className="academic-line">
                                                        <span className="academic-label">{label}</span>
                                                        <span className="academic-value">{dueDate}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    )}

                                    {visaMilestones?.length > 0 && (
                                        <>
                                            <h3 className="data-card__title" style={intakeDeadlines?.length > 0 ? { marginTop: '1.5rem' } : {}}>
                                                <i className='bx bxs-plane-alt'></i>Visa Milestones
                                            </h3>
                                            <ul className="profile-detail-list">
                                                {visaMilestones.map(({ label, dueDate }) => (
                                                    <li key={label} className="academic-line">
                                                        <span className="academic-label">{label}</span>
                                                        <span className="academic-value">{dueDate}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    )}
                                </div>
                            )}

                        </aside>

                        <main className="report-main-grid__center-column">
                            {renderRecommendations()}

                            {scholarshipDetails?.length > 0 && (
                                <div style={{ '--i': allRecommendations.length }}>
                                    <ScholarshipCard scholarships={scholarshipDetails} />
                                </div>
                            )}

                            {allRecommendations.length > 0 && visaAndSOP && <div className="data-card" style={{ '--i': allRecommendations.length + 1 }}>
                                <h3 className="data-card__title"><i className='bx bx-pie-chart-alt-2'></i>Key Metrics Overview</h3>
                                <div className="metrics-card__grid">
                                    {allRecommendations.map((college, index) => (
                                        <div className="metrics-card__grid-item" key={index}>
                                            <h4>{college?.college || college?.name || 'N/A'}</h4>
                                            <div className="donut-graph-container">
                                                <div className="donut-graph-item">
                                                    <div className="donut-graph-viz" data-percent={`${getPercentage(college?.successProbability)}%`} style={{ '--p': isMounted ? getPercentage(college?.successProbability) : 0, '--c': 'var(--success-color)' }} />
                                                    <p className="donut-graph__label">Success</p>
                                                </div>
                                                <div className="donut-graph-item">
                                                    <div className="donut-graph-viz" data-percent={`${getVisaRiskForCollege()}%`} style={{ '--p': isMounted ? getVisaRiskForCollege() : 0, '--c': 'var(--danger-color)' }} />
                                                    <p className="donut-graph__label">Visa Risk</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <small className="disclaimer">*Visa risk is an overall country/profile estimate.</small>
                            </div>}

                            {visaAndSOP && <div className="data-card" style={{ '--i': allRecommendations.length + 2 }}>
                                <h3 className="data-card__title"><i className='bx bx-pen'></i>SOP & Profile Analysis</h3>
                                <h4 className="data-card__subtitle">Profile Improvement Suggestions</h4>
                                <ul className='suggestion-list'>
                                    {Array.isArray(visaAndSOP?.improvementSuggestions) && visaAndSOP.improvementSuggestions.map((s, i) => (<li key={i}>{s}</li>))}
                                </ul>
                                {Array.isArray(visaAndSOP?.sopSuggestions) && visaAndSOP.sopSuggestions.length > 0 && (
                                    <>
                                        <h4 className="data-card__subtitle" style={{ marginTop: '1.5rem' }}>Specific SOP Suggestions</h4>
                                        <ul className='suggestion-list'>
                                            {visaAndSOP.sopSuggestions.map((s, i) => (<li key={i}>{s}</li>))}
                                        </ul>
                                    </>
                                )}
                                <h4 className="data-card__subtitle" style={{ marginTop: '1.5rem' }}>SOP Excerpt</h4>
                                <blockquote className={`sop-card__excerpt ${isSopExpanded ? 'expanded' : ''}`}>{visaAndSOP?.sopExcerpt || 'No SOP excerpt available.'}</blockquote>
                                {(visaAndSOP?.sopExcerpt || '').length > 250 && (<button onClick={toggleSopExpansion} className="expand-text-button">{isSopExpanded ? 'Read Less' : 'Read More'}</button>)}
                            </div>}


                            {admissionRequirements && (
                                <div style={{ '--i': allRecommendations.length + 3 }} className="data-card">
                                    <h3 className="data-card__title">
                                        <i className='bx bxs-id-card'></i> Admission Requirements
                                    </h3>
                                    <ul className="profile-detail-list">
                                        {Object.entries(admissionRequirements).map(([rawKey, val]) => {
                                            const label = rawKey
                                                .replace(/([A-Z])/g, ' $1')
                                                .replace(/^./, str => str.toUpperCase());
                                            return (
                                                <li key={rawKey} className="academic-line">
                                                    <span className="academic-label">{label}</span>
                                                    <span className="academic-value">{val}</span>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            )}

                            {/* --- Career Alignment (inline) --- */}
                            {careerAlignment && (
                                <div style={{ '--i': allRecommendations.length + 4 }} className="data-card">
                                    <h3 className="data-card__title">
                                        <i className='bx bxs-briefcase'></i> Career Alignment
                                    </h3>
                                    <ul className="profile-detail-list">
                                        {Object.entries(careerAlignment).map(([rawKey, val]) => {
                                            const label = rawKey
                                                .replace(/([A-Z])/g, ' $1')
                                                .replace(/^./, str => str.toUpperCase());
                                            return (
                                                <li key={rawKey} className="academic-line">
                                                    <span className="academic-label">{label}</span>
                                                    <span className="academic-value">{val}</span>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            )}
                            {postStudyWorkAndPR && (
                                <div style={{ '--i': allRecommendations.length + 5 }} className="data-card">
                                    <h3 className="data-card__title">
                                        <i className="bx bxs-id-card"></i>Post-Study Work & PR
                                    </h3>
                                    <ul className="profile-detail-list">
                                        {Object.entries(postStudyWorkAndPR).map(([rawKey, val]) => {
                                            const label = rawKey
                                                // convert camelCase or spaced keys into Title Case
                                                .replace(/([A-Z])/g, ' $1')
                                                .replace(/^./, str => str.toUpperCase());
                                            return (
                                                <li key={rawKey} className="academic-line">
                                                    <span className="academic-label">{label}</span>
                                                    <span className="academic-value">{val || 'N/A'}</span>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            )}

                            {peerInfluence && (
                                <div style={{ '--i': allRecommendations.length + 6 }} className="data-card">
                                    <h3 className="data-card__title">
                                        <i className='bx bxs-group'></i>Peer & Parental Influence
                                    </h3>
                                    <ul className="profile-detail-list">
                                        {Object.entries(peerInfluence).map(([rawKey, val]) => {
                                            const label = rawKey
                                                .replace(/([A-Z])/g, ' $1')
                                                .replace(/^./, str => str.toUpperCase());
                                            return (
                                                <li key={rawKey} className="academic-line">
                                                    <span className="academic-label">{label}</span>
                                                    <span className="academic-value">{val || 'N/A'}</span>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            )}


                            {backupPlan && (
                                <div
                                    className="data-card data-card--backup"
                                    style={{ '--i': allRecommendations.length + 7 }}
                                >
                                    <h3 className="data-card__title">
                                        <i className="bx bx-shield-quarter" /> Recommended Backup Plan
                                    </h3>
                                    <p>
                                        <span className="backup-key">
                                            Course and College
                                        </span>
                                        <span className="backup-value">{backupPlan.course}</span>
                                    </p>
                                    <p>
                                        <span className="backup-key">Why it's a safer bet:</span>
                                        <span className="backup-value"> {backupPlan.whySafer}</span>
                                    </p>
                                    <p>
                                        <span className="backup-key">PR Route:</span>
                                        <span className="backup-value"> {backupPlan.prRoute}</span>
                                    </p>
                                </div>

                            )}

                            {predictedQnA && <div className="data-card" style={{ '--i': allRecommendations.length + 8 }}><h3 className="data-card__title"><i className='bx bx-question-mark'></i>Predicted Q&A</h3>
                                {Array.isArray(predictedQnA) && predictedQnA.map((item, index) => (<QnAItem item={item} key={index} />))}
                            </div>}
                            {finalComment && <div className="data-card data-card--verdict" style={{ '--i': allRecommendations.length + 9 }}><h3 className="data-card__title"><i className='bx bxs-comment-error'></i>Analyst's Final Verdict</h3><p>{finalComment}</p></div>}
                        </main>

                        <aside className="report-main-grid__side-column--right">
                            {(() => {
                                let i = 0;
                                const formatStackedKey = (key) => key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
                                return (
                                    <>
                                        {(primaryRecommendation || fullCostOfLiving) && (
                                            <div style={{ '--i': i++ }}>
                                                <CostAnalysis
                                                    fullCostOfLiving={fullCostOfLiving}
                                                    educationCosts={educationCosts}
                                                    primaryRecommendation={primaryRecommendation}
                                                    totalFirstYearInr={livingCosts?.totalFirstYear?.inr}
                                                />
                                            </div>
                                        )}

                                        {jobMarket && (
                                            <div className="data-card" style={{ '--i': i++ }}>
                                                <h3 className="data-card__title"><i className='bx bx-briefcase-alt-2'></i>Job Market Snapshot</h3>

                                                {/* Full-Time Roles */}
                                                <h4 className="data-card__subtitle">Full-Time Roles</h4>
                                                {jobMarket.roles.map((role, idx) => (
                                                    <div key={idx} className="job-card__role-item qna-item">
                                                        <h4>{role.title}</h4>
                                                        <p>
                                                            <span className="text-accent">Salary:</span>{' '}
                                                            {role.salary.local} / {role.salary.inr}
                                                        </p>
                                                        <p>
                                                            <span className="text-accent">Demand:</span>{' '}
                                                            <span className={`status-badge ${role.demandLevel.toLowerCase()}`}>
                                                                {role.demandLevel}
                                                            </span>
                                                        </p>
                                                        <p>
                                                            <span className="text-accent">PR Support:</span>{' '}
                                                            {role.prSupport}
                                                        </p>
                                                    </div>
                                                ))}

                                                {/* Part-Time Opportunities */}
                                                {jobMarket.partTimeOpportunities.length > 0 && (
                                                    <>
                                                        <h4 className="data-card__subtitle" style={{ marginTop: '1.5rem' }}>
                                                            Part-Time Opportunities
                                                        </h4>
                                                        {jobMarket.partTimeOpportunities.map((job, idx) => (
                                                            <div key={idx} className="job-card__role-item qna-item">
                                                                <h4>{job.role}</h4>
                                                                <p>
                                                                    <span className="text-accent">Avg. Wage:</span>{' '}
                                                                    {job.wage.local} / {job.wage.inr}
                                                                </p>
                                                                <p>
                                                                    <span className="text-accent">Finding Difficulty:</span>{' '}
                                                                    <span className={`status-badge ${job.findingDifficulty.toLowerCase()}`}>
                                                                        {job.findingDifficulty}
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        ))}
                                                    </>
                                                )}
                                            </div>
                                        )}


                                        {flightCostsTips && (
                                            <div className="data-card flight-travel-tips" style={{ '--i': i++ }}>
                                                <h3 className="data-card__title"><i className='bx bxs-plane-alt'></i>Flight & Travel Tips</h3>
                                                <div className="flight-travel-body" style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                                    <div>
                                                        <p className="flight-travel-label">Avg. Fare</p>
                                                        <p className="flight-travel-value">
                                                            {flightCostsTips.fromToAverageCost?.inr
                                                                ? `${formatToLakhs(flightCostsTips.fromToAverageCost.from.inr)} - ${formatToLakhs(flightCostsTips.fromToAverageCost.to.inr)}`
                                                                : flightCostsTips.fromToAverageCost}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p className="flight-travel-label">Off-Peak Insight</p>
                                                        <p className="flight-travel-value">{flightCostsTips.peakOffSeasonInsights || 'N/A'}</p>
                                                    </div>
                                                    <div>
                                                        <p className="flight-travel-label">Best Booking</p>
                                                        <p className="flight-travel-value">{flightCostsTips.bestBookingPeriod || 'N/A'}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )}


                                        {roi && <div className="data-card return-on-investment" style={{ '--i': i++ }}>
                                            <h3 className="data-card__title"><i className='bx bxs-coin-stack'></i>Return on Investment</h3>
                                            <div className="travel-lifestyle-body" style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                                {roi.averageGraduateSalary && (
                                                    <div>
                                                        <p className="return-on-label">Avg Grad Salary</p>
                                                        <p className="return-on-value">{roi.averageGraduateSalary.local} / {roi.averageGraduateSalary.inr}
                                                            {roi.averageGraduateSalary.local || 'N/A'}
                                                            {' / '}
                                                            {roi.averageGraduateSalary.inr || 'N/A'}
                                                        </p>
                                                    </div>
                                                )}

                                                {roi.loanRepaymentEase && <div>
                                                    <p className="return-on-label">Loan Ease</p>
                                                    <p style={{ margin: 0 }}>{roi.loanRepaymentEase}</p>
                                                </div>}
                                                {roi.earningWhileStudying && <div>
                                                    <p className="return-on-label">Earn While Study</p>
                                                    <p className="return-on-value">{roi.earningWhileStudying}</p>
                                                </div>}
                                            </div>
                                        </div >}

                                        {countrySafetyAndPreference && (
                                            <div className="data-card country-safety-info" style={{ '--i': i++ }}>
                                                <h3 className="data-card__title"><i className='bx bxs-flag-alt'></i>Country & Safety Info</h3>
                                                <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                                    {Object.entries(countrySafetyAndPreference).map(([key, value]) => value && (
                                                        <div key={key}>
                                                            <p className="country-safety-label">{formatStackedKey(key)}</p>
                                                            <p className="country-safety-value">{value}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {connectivityLifestyle && (
                                            <div className="data-card travel-lifestyle" style={{ '--i': i++ }}>
                                                <h3 className="data-card__title"><i className='bx bx-planet'></i>Travel & Lifestyle</h3>
                                                <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                                    {Object.entries(connectivityLifestyle).map(([key, value]) => value && (
                                                        <div key={key}>
                                                            <p className="tl-label">{formatStackedKey(key)}</p>
                                                            <p className="tl-value">{String(value)}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {prPathway && (
                                            <div className="data-card" style={{ '--i': i++ }}>
                                                <h3 className="data-card__title"><i className='bx bx-line-chart'></i>PR Pathway Roadmap</h3>
                                                <ul className="pathway-card__timeline">
                                                    {Array.isArray(prPathway?.timelineSteps) && prPathway.timelineSteps.map((item, index) => (
                                                        <li className="pathway-card__timeline-event" key={item?.step || index}>
                                                            <p className="step-title">{item?.step || 'N/A'}</p>
                                                            <p className="step-duration">{item?.duration || 'N/A'}</p>
                                                        </li>
                                                    ))}
                                                </ul>
                                                {/* <div className="pr-details-section">
                                                    <p><span className="text-accent">Est. Final CRS Score:</span> {prPathway.estimatedFinalCRS || 'N/A'}</p>
                                                    <p><span className="text-accent">CRS Improvement:</span> {prPathway.crsImprovementSuggestions || 'N/A'}</p>
                                                </div> */}
                                            </div>
                                        )}

                                        {finalActionPlan && <div className="data-card" style={{ '--i': i++ }}>
                                            <h3 className="data-card__title"><i className='bx bx-list-check'></i>Final Action Plan</h3>
                                            <h4 className="data-card__subtitle">Complete To-Do List</h4>
                                            <ul className='icon-list'>
                                                {Array.isArray(finalActionPlan?.todoList) && finalActionPlan.todoList.map((step, idx) => (<li key={idx}><i style={{ color: "var(--primary-color)" }} className='bx bx-checkbox'></i>{step}</li>))}
                                            </ul>
                                            <h4 className="data-card__subtitle" style={{ marginTop: '1.5rem' }}>Immediate Next 3 Steps</h4>
                                            <ol className="suggestion-list">
                                                {Array.isArray(finalActionPlan?.next3Steps) && finalActionPlan.next3Steps.map((step, idx) => (<li key={idx}>{step}</li>))}
                                            </ol>
                                        </div>}

                                        {footerResources && <div className="data-card" style={{ '--i': i++ }}>
                                            <h3 className="data-card__title"><i className='bx bx-link'></i>Helpful Resources</h3>
                                            <ul className='icon-list'>
                                                {footerResources?.resumeBuilderLink && <li><i className='bx bx-file'></i><a href={footerResources.resumeBuilderLink} target="_blank" rel="noopener noreferrer">Resume Builder</a></li>}
                                                {footerResources?.sopGeneratorLink && <li><i className='bx bx-pen'></i><a href={footerResources.sopGeneratorLink} target="_blank" rel="noopener noreferrer">SOP Generator</a></li>}
                                                {Array.isArray(footerResources?.accommodationPlatforms) && footerResources.accommodationPlatforms.map(link => (
                                                    <li key={link}><i className='bx bx-home'></i><a href={link} target="_blank" rel="noopener noreferrer">Accommodation</a></li>
                                                ))}
                                                {footerResources?.budgetCalculatorLink && <li><i className='bx bxs-calculator'></i><a href={footerResources.budgetCalculatorLink} target="_blank" rel="noopener noreferrer">Budget Calculator</a></li>}
                                            </ul>
                                        </div>}
                                    </>
                                );
                            })()}
                        </aside>
                    </div>
                </div>
            </div >
        </>
    );
};
export default AIReportDisplay;